export default "__VITE_ASSET__01274711__"